import ModalElement from './ModalElement';
import PermissionDeniedModal from '../Components/PermissionDeniedModal';
class PermissionDeniedModalElement extends ModalElement {
    constructor() {
        super(...arguments);
        this.element = PermissionDeniedModal;
    }
}
export default PermissionDeniedModalElement;
